import { Route } from '@angular/router';
import { accessGuard } from '@guards';

export const appRoutes: Route[] = [
  {
    path: '',
    canActivate: [accessGuard],
    loadComponent: () =>
      import('./pages/loader-page/loader-page.component').then(
        (m) => m.LoaderPageComponent,
      ),
  },
  {
    path: 'intro',
    canActivate: [accessGuard],
    loadComponent: () =>
      import('./pages/intro-page/intro-page.component').then(
        (m) => m.IntroPageComponent,
      ),
  },
  {
    path: 'video',
    canActivate: [accessGuard],
    loadComponent: () =>
      import('./pages/video-page/video-page.component').then(
        (m) => m.VideoPageComponent,
      ),
  },
  {
    path: 'equipment',
    canActivate: [accessGuard],
    loadComponent: () =>
      import('./pages/equipment-page/equipment-page.component').then(
        (m) => m.EquipmentPageComponent,
      ),
  },
  {
    path: 'preparation',
    canActivate: [accessGuard],
    loadComponent: () =>
      import('./pages/preparation-page/preparation-page.component').then(
        (m) => m.PreparationPageComponent,
      ),
  },
  {
    path: 'simulation',
    canActivate: [accessGuard],
    loadComponent: () =>
      import('./pages/simulation-page/simulation-page.component').then(
        (m) => m.SimulationPageComponent,
      ),
  },
  {
    path: 'evaluation',
    canActivate: [accessGuard],
    loadComponent: () =>
      import('./pages/evaluation-page/evaluation-page.component').then(
        (m) => m.EvaluationPageComponent,
      ),
  },
  {
    path: 'end',
    canActivate: [accessGuard],
    loadComponent: () =>
      import('./pages/end-page/end-page.component').then(
        (m) => m.EndPageComponent,
      ),
  },
  {
    path: 'connect',
    loadComponent: () =>
      import('./pages/connect-page/connect-page.component').then(
        (m) => m.ConnectPageComponent,
      ),
  },
  {
    path: '**',
    pathMatch: 'full',
    loadComponent: () =>
      import('./pages/connect-page/connect-page.component').then(
        (m) => m.ConnectPageComponent,
      ),
  },
];
